var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "merged-page" }, [
    _c(
      "div",
      { staticClass: "route-page-content" },
      [
        _c("AutomationMenu", {
          model: {
            value: _vm.selectedTab,
            callback: function ($$v) {
              _vm.selectedTab = $$v
            },
            expression: "selectedTab",
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "page-content-wrapper" },
          [
            _vm.isSelected("all-automations") ? _c("AutomationList") : _vm._e(),
            _vm._v(" "),
            _vm.isSelected("scheduled-automations")
              ? _c("AutomationList", { attrs: { type: "timer" } })
              : _vm._e(),
            _vm._v(" "),
            _vm.isSelected("event-based-automations")
              ? _c("AutomationList", { attrs: { type: "event" } })
              : _vm._e(),
            _vm._v(" "),
            _vm.isSelected("button-automations")
              ? _c("AutomationList", { attrs: { type: "button" } })
              : _vm._e(),
            _vm._v(" "),
            _vm.isSelected("webhook-automations")
              ? _c("AutomationList", { attrs: { type: "webhook" } })
              : _vm._e(),
            _vm._v(" "),
            _vm.isSelected("automation-insights")
              ? _c("AutomationGeneralInsights")
              : _vm._e(),
            _vm._v(" "),
            _vm.isSelected("automation-sandbox")
              ? _c("AutomationSanbox")
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }